import React, { Component } from 'react';
// import axios from 'axios';

import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';

import { Select, Collapse, Input, Divider, Tag, Table, Button, message as alert } from 'antd';
import propTypes from 'prop-types';
// local
import './SendSolicitation.scss';
import { isEmail } from '../../../utils/validationUtils';
import { querySupplierCapsForautoComplete, emailSuppliers } from './graphql';
import logService from '../../../graphql/logging';

const Option = Select.Option;
const Panel = Collapse.Panel;
const columns = [
  {
    title: 'Solicitation #',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'NSN #',
    dataIndex: 'purchaseRequest.nsnPart',
    key: 'age',
  },
  {
    title: 'Material',
    dataIndex: 'purchaseRequest.material',
    key: 'age',
  },

  {
    title: 'Method',
    dataIndex: 'purchaseRequest.method',
    key: 'address',
  },
  {
    title: 'Tooling',
    key: 'tooling',
    dataIndex: 'tooling',
    render: tooling => {
      const unique = [...new Set(tooling)];
      return (
        <span>
          {unique.map(tag => {
            const color = 'geekblue';
            if (tag) {
              return (
                <Tag color={color} key={tag}>
                  {tag.toUpperCase()}
                </Tag>
              );
            }

            return '';
          })}
        </span>
      );
    },
  },
];

export default class SendSolicitations extends Component {
  static propTypes = {
    solicitationsToSend: propTypes.object.isRequired,
    organizationsName: propTypes.string.isRequired,
    organizationsCage: propTypes.string.isRequired,
    usersName: propTypes.string.isRequired,
    closeModal: propTypes.func.isRequired,
  };

  static defaultProps = {};

  state = {
    suppliers: null,
    cages: [],
    companies: [],
    selectedCages: [],
    selectedCompanies: [],
    pocNumber: '',
    pocName: '',
    pocEmail: '',
    visibleEmails: [],
    level: '',
    message: '',
    selectedEmails: [],
    solicitationList: [],
    pocNumberLevel: undefined,
    pocEmailLevel: undefined,
    pocNameLevel: undefined,
    emailListLevel: undefined,
    emailListMessage: undefined,
    pocNumberMessage: undefined,
    pocEmailMessage: undefined,
    pocNameMessage: undefined,
    activeKey: '1',
    loading: false,
  };

  componentDidMount = async () => {
    const cages = [];
    const companies = [];
    const tempCompany = [];
    const res = await querySupplierCapsForautoComplete();
    res.map(supplier => {
      if (tempCompany.indexOf(supplier.company) !== -1) {
        console.log('confused screaming');
      } else {
        tempCompany.push(supplier.company);
        cages.push(
          <Option key={supplier.cage} value={supplier.cage}>
            {supplier.cage}
          </Option>,
        );
        companies.push(
          <Option key={supplier.company} value={supplier.company}>
            {supplier.company}
          </Option>,
        );
      }
      return '';
    });
    const uniqueCages = [...new Set(cages)];
    const uniqueCompanies = [...new Set(companies)];
    let solicitationList = [];
    if (
      this.props.solicitationsToSend &&
      this.props.solicitationsToSend.solicitationList
    ) {
      solicitationList = this.props.solicitationsToSend.solicitationList.map(
        solicitations => solicitations.id,
      );
    }

    this.setState({
      cages: uniqueCages,
      companies: uniqueCompanies,
      suppliers: res,
      solicitationList,
    });
  };

  handleChangeOfCages = cage => {
    console.log(this.state.suppliers);
    const emails = [...this.state.selectedEmails];
    const companies = [...this.state.selectedCompanies];
    const cages = [...this.state.selectedCages];
    cages.push(cage);
    const obj = this.state.suppliers.find(o => o.cage === cage);
    console.log(obj.email);
    emails.push(obj.email);
    companies.push(obj.company);
    this.setState({
      selectedCompanies: companies,
      selectedCages: cages,
      selectedEmails: emails,
    });
  };

  handleChangeOfCompany = company => {
    console.log(this.state.suppliers);
    const companies = [...this.state.selectedCompanies];
    const emails = [...this.state.selectedEmails];
    const cages = [...this.state.selectedCages];
    companies.push(company);

    const obj = this.state.suppliers.find(o => o.company === company);
    console.log(obj);
    emails.push(obj.email);

    cages.push(obj.cage);
    this.setState({
      selectedCages: cages,
      selectedCompanies: companies,
      selectedEmails: emails,
    });
  };

  handleDeselectCage = cage => {
    const companies = [...this.state.selectedCompanies];
    const cages = [...this.state.selectedCages];
    const emails = [...this.state.selectedEmails];

    let index = cages.indexOf(cage);
    cages.splice(index, 1);
    const obj = this.state.suppliers.find(o => o.cage === cage);
    index = companies.indexOf(obj.company);

    companies.splice(index, 1);
    index = emails.indexOf(obj.email);
    emails.splice(index, 1);
    this.setState({
      selectedCompanies: companies,
      selectedCages: cages,
      selectedEmails: emails,
    });
  };

  handleDeselectCompany = company => {
    const companies = [...this.state.selectedCompanies];
    const cages = [...this.state.selectedCages];
    const emails = [...this.state.selectedEmails];

    let index = companies.indexOf(company);
    companies.splice(index, 1);
    const obj = this.state.suppliers.find(o => o.company === company);
    index = cages.indexOf(obj.cage);

    cages.splice(index, 1);

    index = emails.indexOf(obj.email);
    emails.splice(index, 1);
    this.setState({
      selectedCompanies: companies,
      selectedCages: cages,
    });
  };

  _onChange = e => this.setState({ [e.target.name]: e.target.value });

  _handleEmails = email => {
    const message = isEmail(email);
    if (message) {
      this.setState({
        level: 'error',
        message,
      });
      setTimeout(() => {
        this.setState({
          level: '',
          message: '',
        });
      }, 1000);
      return;
    }
    const emails = [...this.state.visibleEmails];

    emails.push(email);
    this.setState({
      visibleEmails: emails,
    });
  };

  _handleUnselectingEmails = email => {
    const emails = [...this.state.visibleEmails];
    const index = emails.indexOf(email);
    emails.splice(index, 1);
    this.setState({
      visibleEmails: emails,
    });
  };

  _buildLinks = solicitationsToSend => {
    if (solicitationsToSend && solicitationsToSend.solicitationList) {
      const solicitationList = solicitationsToSend.solicitationList.map(
        solicitations => {
          const link = `https://icon.nffs.org/solicitations/${solicitations.id
            }`;

          return (
            <li>
              {' '}
              <a href={link}>{solicitations.id}</a>
            </li>
          );
        },
      );

      return <ul>{solicitationList}</ul>;
    }
    return '';
  };

  _handleSubmit = async () => {
    const obj = {
      pocName: this.state.pocName,
      pocEmail: this.state.pocEmail,
      pocPhone: this.state.pocNumber,
      cage: this.props.organizationsCage,
      company: this.props.organizationsName,
      emailList: [...this.state.selectedEmails, ...this.state.visibleEmails],
      solicitationList: this.state.solicitationList,
    };

    const keys = Object.keys(obj).filter(e => {
      if (!obj[e]) {
        return e;
      }
      return '';
    });
    if (!obj.emailList[0]) {
      keys.push('emailList');
    }
    keys.map(key => {
      if (key === 'pocPhone') {
        key = 'pocNumber';
      }
      if (key.includes('poc')) {
        this.setState({
          activeKey: '1',
        });
      }
      const level = `${key}Level`;
      const message = `${key}Message`;
      if (key === 'emailList') {
        this.setState({
          [level]: 'error',
          [message]: 'At least one field is required',
        });
      } else {
        this.setState({
          [level]: 'error',
          [message]: 'this is a required field',
        });
      }
      setTimeout(() => {
        this.setState({
          [level]: '',
          [message]: '',
        });
      }, 2000);
      return '';
    });

    if (!keys[0]) {
      this.setState({
        loading: true,
      });
      const res = await emailSuppliers(obj);
      console.log(res);



      this.setState({
        loading: false,
      });
      if (res.message === 'success') alert.success(res.message);
      else alert.error(res.message);

      setTimeout(() => {
        this.props.closeModal(null, res.message);
      }, 2000);
    }
  };

  _changeActiveKey = key => {
    this.setState({
      activeKey: key,
    });
  };
  render() {
    const {
      cages,
      companies,
      selectedCompanies,
      selectedCages,
      pocNumber,
      pocEmail,
      pocName,
      pocNumberLevel,
      pocEmailLevel,
      pocNameLevel,
      emailListLevel,
      emailListMessage,
      pocNumberMessage,
      pocEmailMessage,
      pocNameMessage,
      visibleEmails,
      level,
      message,
    } = this.state;
    const {
      solicitationsToSend,
      organizationsCage,
      organizationsName,
      usersName,
      closeModal,
    } = this.props;

    const postLogsBody = {
      level: 'info',
      message: JSON.stringify(solicitationsToSend),
      className: 'pn-nffs-solicitation-search/src/components/Modals/sendSolicitations/SendSolicitation.jsx',
      methodName: '_changeActiveKey',
    };
    try {
      logService(postLogsBody);
    } catch (error) {
      console.error({ msg: 'Error Unable to send logs to DB2!', postLogsBody }, error);
    }


    // this._validateForm();
    const solicitationList = this._buildLinks(solicitationsToSend);
    return (
      <div>
        <Form.Item validateStatus={emailListLevel} help={emailListMessage}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '50%' }}>
              <p style={{ margin: 0 }}>
                Add by Cage: <br />
              </p>
              <Select
                mode="multiple"
                style={{ width: '90%' }}
                placeholder="search By CAGE"
                value={selectedCages}
                onSelect={this.handleChangeOfCages}
                onDeselect={this.handleDeselectCage}
              >
                {cages}
              </Select>
            </div>
            <div style={{ width: '50%' }}>
              <p style={{ margin: 0 }}>
                Add by Company: <br />{' '}
              </p>
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="Search by Company Name"
                value={selectedCompanies}
                onSelect={this.handleChangeOfCompany}
                onDeselect={this.handleDeselectCompany}
              // onChange={handleChange}
              >
                {companies}
              </Select>
            </div>
          </div>
          <br />
          <Divider>
            <b>or</b>
          </Divider>
          <div className="tag-wrapper">
            <Form.Item
              label="Add by email:"
              validateStatus={level}
              help={message}
            >
              <Select
                onSelect={this._handleEmails}
                mode="tags"
                style={{ width: '100%' }}
                dropdownStyle={{ display: 'none' }}
                placeholder="Add emails then press enter"
                value={visibleEmails}
                onDeselect={this._handleUnselectingEmails}
              />
            </Form.Item>
          </div>
        </Form.Item>

        <br />
        <Collapse
          activeKey={this.state.activeKey}
          onChange={this._changeActiveKey}
          accordion
        >
          <Panel header="Contact Information" key="1">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '45%' }}>
                Name:
                <Input
                  placeholder="Basic usage"
                  defaultValue={usersName}
                  disabled
                />
              </div>
              <div style={{ width: '50%' }}>
                Company Name:
                <Input
                  disabled
                  placeholder="Basic usage"
                  defaultValue={organizationsName}
                />
              </div>
            </div>
            <br />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '45%' }}>
                CAGE:
                <Input
                  disabled
                  placeholder="Basic usage"
                  defaultValue={organizationsCage}
                />
              </div>
              <div style={{ width: '50%' }}>
                <Form.Item
                  label="* Point of Contact:"
                  validateStatus={pocNameLevel}
                  help={pocNameMessage}
                >
                  <Input
                    placeholder="Point of Contact Name"
                    value={pocName}
                    name="pocName"
                    onChange={this._onChange}
                  />
                </Form.Item>
              </div>
            </div>
            <br />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '45%' }}>
                <Form.Item
                  label="* POC Email:"
                  validateStatus={pocEmailLevel}
                  help={pocEmailMessage}
                >
                  <Input
                    placeholder="Point of Contact Email"
                    value={pocEmail}
                    name="pocEmail"
                    onChange={this._onChange}
                  />
                </Form.Item>
              </div>
              <div style={{ width: '50%' }}>
                <Form.Item
                  label="* POC phone:"
                  validateStatus={pocNumberLevel}
                  help={pocNumberMessage}
                >
                  <Input
                    placeholder="Point of Contact Phone"
                    value={pocNumber}
                    name="pocNumber"
                    onChange={this._onChange}
                  />
                </Form.Item>
              </div>
            </div>
          </Panel>

          <Panel header="Solicitations" key="2">
            <div>
              <Table
                size="middle"
                columns={columns}
                dataSource={solicitationsToSend.solicitationList}
                bordered
              />
            </div>
          </Panel>
          <Panel header="Preview" key="3">
            <div>
              Subject: {organizationsName} {organizationsCage} ICON Solicitation
              Request for Quote
              <br />
              Reference: Solicitation(s) List {solicitationList} Dear Supplier,
              <br />
              Please provide your quote for the Referenced Solicitations
              pertaining to your supplier capabilities, tooling and associated
              part numbers. For more information please contact {
                pocName
              } at {pocEmail} or {pocNumber}
              <br />
              To view more solicitations please follow the link at:
              <a href="https://ICON.NFFS.ORG">ICON.NFFS.ORG</a> If you do not
              have an account you can also register at the above ICON website.
              <br />
              Cordially,
              <br />
              ICON Supplier Capabilities
              <br />
              Request For Quotation Processing
            </div>
          </Panel>
        </Collapse>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '16px',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '11%',
              justifyContent: 'space-between',
            }}
          >
            <Button type="danger" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              type="primary"
              loading={this.state.loading}
              onClick={this._handleSubmit}
            >
              Send
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/sendSolicitations/SendSolicitation.jsx